const global = window

inputs.alias.steps = 'tabs'

inputs.types.tabs = function (data, name, niceName, type, input, parent, inputWindow) {

    inputs.fn.tabs = {
        set(input, tab) {
            if (typeof tab === 'object' && tab !== null) {
                tab = $(tab);
                if (tab.hasClass('tabs')) {
                    tab = tab.find('> .tabs__nav, > .tabs__nav__wrap > .tabs__nav');
                }
                if (tab.hasClass('tabs__btn')) {
                    tab = $('#'+tab.attr('aria-controls'))
                }
                if (!tab.hasClass('tabs__pane')) {
                    tab = tab.closest('.tabs__nav')
                }
                if (tab.hasClass('tabs__pane')) {
                    tab = tab.parent().find('.tabs__nav').find('#btn-'+tab.attr('name')).index()
                }
                else {
                    tab = null;
                }
            }
            input = $(input);
            if (!input.hasClass('.tabs')) {
                input = input.closest('.tabs')
            }
            if (input && tab !== null) {
                input.tabs('option', 'active', tab);
            }
        },
    }

    data.activate = function(event, ui) {
        const panel = (ui.newPanel) ? ui.newPanel : ui.panel;

        // Récupérer données de l'onglet
        const tabData = panel.data('data');

        // Flex pour pleine hauteur
        if (tabData && tabData.full) panel.css("display","flex");

        // Changer valeur
        const currentTab = $(input).find(' > ul .ui-tabs-active, > .tabs__nav__wrap > ul .ui-tabs-active')
        $(input).val(currentTab.index())
        if ($('#' + currentTab.attr('aria-controls')).attr('value')) {
            $(input).val($('#' + currentTab.attr('aria-controls')).attr('value'))
        }

        // Hack IV
        panel.find('.iv').each(function () {
            let tabIvPlugin = $(input).data('plugin')
            if (tabIvPlugin && tabIvPlugin.resize) {
                tabIvPlugin.resize()
        }
        })

        // Mise à jours grandeur de fenêtre
        if (tabData) {
            const newWidth = tabData.width
            const newHeight = tabData.height
            if (newWidth || newHeight) {
                const win = $.window.find(input)
                if (win) {
                    win.resize(newWidth, newHeight)
                    win.alignCenter()
                }
            }
        }

        // Save tabs
        if ($(input).attr('name')) {
            if ($(input).attr('value')) global.selectedTabsRecords[$(input).attr('name')] = $(input).attr('value');
        }

        // Apply behavior
        BEHAV.apply(ui.newPanel, 'show');

        // Resize trigger
        window.dispatchEvent(new Event('resize'));

        // Change event
        $(input).change();
    };

    input.tabs({
        activate: data.activate,
        create(event, ui) {
            const currentTab = $(this).find(' > ul .ui-tabs-active, > .tabs__nav__wrap > ul .ui-tabs-active')
            $(this).val(currentTab.index())
            if ($('#' + currentTab.attr('aria-controls')).attr('value')) {
                $(this).val($('#' + currentTab.attr('aria-controls')).attr('value'))
            }

            // Load saved tab
            const loadTabIndex = global.selectedTabsRecords[$(input).attr('name')];
            if ($(input).attr('name') && ((loadTabIndex && loadTabIndex > -1) || loadTabIndex === 0)) {
                console.log (loadTabIndex);
                $(input).tabs('option', 'noAnimation', true);
                $(input).tabs('option', 'active', loadTabIndex);
                $(input).tabs('option', 'noAnimation', false);
            }

            setTimeout(function() {
                global.noQ = true
                data.activate(event, ui);
                global.noQ = false
            }, 100)

            if ($(event.target).find('.tabs__nav').children('.tabs__btn').length < 2) {
                $(event.target).find('.tabs__nav').addClass('tabs__nav--notabs')
                if ($(event.target).find('.tabs__nav > .tabs__addon').length) {
                    $(event.target).find('.tabs__nav > .tabs__btn').hide()
                }
                else {
                    $(event.target).find('.tabs__nav').hide()
                }
            }
        },
        beforeLoad: function( event, ui ) {
            // disable AJAX loading
            event.preventDefault();
        }
    })
    input.tabs("option", "classes.ui-tabs", "tabs");
    input.tabs("option", "classes.ui-tabs-nav", "tabs__nav");
    input.tabs("option", "classes.ui-tabs-panel", "tabs__pane");
    input.tabs("option", "classes.ui-tabs-tab", "tabs__btn");
    return data
}
